import createSpacing from '@material-ui/core/styles/createSpacing'

const SPACING = 10

export default createSpacing(SPACING)
